<script lang="ts">
	import Text from '$lib/components/Text.svelte';
	import Link from '$lib/components/navigation/Link.svelte';
	import Button from '$lib/components/util/Button.svelte';
	import Media from '$lib/components/media/Media.svelte';
	import { page } from '$app/stores';
	import {
		convertSchemaToHtml,
		formatPrice,
		formatPriceRange,
		formatWeight
	} from '$lib/util/ecom/format';
	import Dropdown from '$lib/components/inputs/Dropdown.svelte';
	import { getVariantName } from '$lib/util/ecom/util';
	import GlobalMedia from '$lib/components/media/GlobalMedia.svelte';
	import { addToCart, quickCheckout } from '$lib/stores/shopStore';

	import border from '$lib/assets/img/border-tile-white.png';
	import borderYellow from '$lib/assets/img/border-tile-yellow.png';
	import { options } from '$lib/stores/trackingStore';
	import { getText } from '$lib/util/translations';
	import { injectDiscounts } from '$lib/util/ecom/discounts';

	export let product: any;
	export let filterSize: any = undefined;
	export let priceRange: [number, number] | undefined = undefined;

	let variants: any[] = [];
	$: filteredVariants = variants.filter((v) => v.variantName != null);
	let initalSelectedVariant = 0;
	$: selectedVariant = initalSelectedVariant;

	export let isSubscription: boolean = false;

	$: comparePrice = variants[selectedVariant]?.compareAtPriceV2;
	$: price = variants[selectedVariant]?.priceV2;

	$: {
		let filteredVariants = variants;

		if (priceRange) {
			filteredVariants = filteredVariants.filter(
				(v) => v.priceV2.amount >= priceRange[0] && v.priceV2.amount <= priceRange[1]
			);
		}

		if (filterSize) {
			filteredVariants = filteredVariants.filter((v) => {
				for (const option of v?.selectedOptions ?? []) {
					if (option.value === filterSize) {
						return true;
					}
				}
				return false;
			});
		}

		initalSelectedVariant = variants.findIndex((v) => v.id === filteredVariants?.[0]?.id);
		// if no variant matches it returns -1 in which case we do not render the card
	}

	$: {
		const newVariants: any[] = [];
		for (const v of product?.variants?.edges ?? []) {
			newVariants.push({
				...v.node,
				variantName: getVariantName(v.node)
			});
		}
		variants = newVariants;
	}

	$: previewImage =
		variants[selectedVariant]?.image?.url ??
		product?.media?.edges?.[0]?.node?.previewImage?.url ??
		'';

	// function previewImage() {
	// 	// console.log(variants[selectedVariant]?.image?.url);

	// 	if (!variants[selectedVariant]?.image?.url) {
	// 		return product && product.media && product.media.edges.length > 0
	// 			? product.media.edges[0].node.previewImage.url
	// 			: '';
	// 	}

	// 	return variants[selectedVariant].image?.url;
	// }

	let overlayVideoData: any;
	let videoPlayer: any;

	$: {
		if (product?.card_overlay_image?.reference?.mediaContentType === 'VIDEO') {
			for (const videoData of product?.card_overlay_image?.reference?.sources ?? []) {
				if (videoData.width <= 480) {
					overlayVideoData = videoData;
				}
			}
		}
	}

	function playVideo() {
		if (videoPlayer) {
			videoPlayer.play();
		}
	}

	function pauseVideo() {
		if (videoPlayer) {
			videoPlayer.pause();
		}
	}
</script>

{#if product && selectedVariant !== -1}
	<div class="product" class:no-hover={!variants[selectedVariant]?.availableForSale}>
		<Link type="internal" link={'shop/' + product.handle} class="image">
			<div class="image-container">
				<img src={previewImage} loading="lazy" class="product-image" alt={product.title ?? ''} />
				{#if !variants[selectedVariant]?.availableForSale}
					<div class="sold-out">
						<Text tag="span" key="ecom_sold_out" />
					</div>
				{/if}
				<div
					class="overlay"
					on:mouseenter={() => {
						playVideo();
					}}
					on:mouseleave={() => {
						pauseVideo();
					}}
				>
					<div class="row {isSubscription ? 'subscription' : ''}">
						<div class="left">
							<div class="tags">
								{#each product.tags.filter((item) => item != 'special_subscription') ?? [] as tag}
									<div class="tag">{tag}</div>
								{/each}
							</div>
						</div>
					</div>
				</div>
			</div>
		</Link>

		<div
			class="content {isSubscription ? 'subscription' : ''}"
			style="--border-white: url('{border}'); --border-yellow: url('{borderYellow}')"
		>
			<div class="text">
				<div class="product-name {isSubscription ? 'subscription' : ''}">
					<Link type="internal" link={'shop/' + product.handle}>
						{product.title}
					</Link>
				</div>
				<div class="divider desktop mobile" />
				{#if !isSubscription && !(!product.subtitle_1?.value && filteredVariants.length === 0)}
					<div class="row center {$page.data.langDirection}">
						<div class="left">
							<div class="description">{product.subtitle_1?.value ?? ''}</div>
						</div>
						{#if product.subtitle_1?.value && filteredVariants.length > 0}
							<div class="divider-v" />
							<div class="divider mobile" />
						{/if}
						{#if filteredVariants.length > 0}
							<div class="right select-col">
								<div class="variant-select">
									<Dropdown bind:value={selectedVariant} type="small">
										{#each filteredVariants as variant, idx}
											{#key variant.variantName}
												<option value={idx}>
													{variant.variantName}
												</option>
											{/key}
										{/each}
									</Dropdown>
								</div>
							</div>
						{/if}
					</div>
					<div class="divider desktop" />
				{/if}

				<div class="row bottom">
					{#if !isSubscription}
						<div class="left">
							<span class="price">
								{#if comparePrice}
									<span class="compare-price" style="margin-inline-end: 8px">
										{formatPrice(
											injectDiscounts(comparePrice?.amount),
											comparePrice?.currencyCode,
											$page.params.lang
										)}
									</span>
								{/if}
								{formatPrice(
									injectDiscounts(price?.amount),
									price?.currencyCode,
									$page.params.lang
								)}
							</span>
							<span class="vat"><Text tag="span" key="ecom_vat_text" /></span>
						</div>
						<div class="right">
							{#if variants[selectedVariant]?.availableForSale}
								<button
									type="button"
									class="add-button"
									aria-label={getText($page.data.globalTexts, 'ecom_add_to_cart').text}
									on:click={() =>
										addToCart(
											variants[selectedVariant]?.id,
											1,
											price?.amount,
											price?.currencyCode,
											product.title,
											previewImage
										)}
								>
									<div class="button-text">
										<Text key="ecom_add_to_cart" />
									</div>
									<GlobalMedia key="icon-cart-add" />
								</button>
							{/if}
						</div>
					{:else}
						<div class="subscribe-button">
							<Link type="internal" link={'shop/' + product.handle + '#subscription'}>
								<Button textKey="subscribe_now" style="dark" />
							</Link>
						</div>
					{/if}
				</div>
			</div>
		</div>
	</div>
{/if}

<style scoped lang="scss">
	.product {
		position: relative;
		display: flex;
		flex-direction: column;
		:global(a) {
			height: 100%;
		}

		.image {
			position: relative;

			background: white;
			display: flex;
			align-items: center;
		}

		&.no-hover {
			:global(a) {
				cursor: not-allowed;
			}
		}

		.sold-out {
			position: absolute;
			bottom: calc(v(content-gap-xs) + 4px); // 4px is the border-image-width
			inset-inline-start: v(content-gap-xs);
			background: color(yellow_01);
			color: color(black);
			@include font(h6);
			display: flex;
			justify-content: center;
			width: calc(100% - 2 * v(content-gap-xs));
			padding: 8px;
			border-radius: v(border-radius);
		}

		.image-container {
			width: 100%;
			height: 100%;
			position: relative;
			overflow: hidden;

			.product-image {
				width: 100%;
				height: 100%;
				aspect-ratio: 1 / 1;
				object-fit: cover;
			}
		}

		.overlay {
			position: absolute;
			inset: 0;
			padding: v(content-padding-sm);
			z-index: 2;

			@media (max-width: 900px) {
				padding: v(content-padding-xs);
			}

			.row {
				display: flex;
				justify-content: space-between;
				gap: v(content-padding-sm);
			}

			.tags {
				display: flex;
				flex-wrap: wrap;

				.tag {
					@include font(h6);
					background: color(yellow_01);
					border-radius: 4px;
					padding: 6px v(content-padding) 6px v(content-padding);
					margin-inline-end: v(content-padding-sm);
					margin-bottom: v(content-padding-xs);
					color: color(black);
				}
			}

			.text {
				transition: all 0.3s ease;
				opacity: 0;
				color: black;
			}
		}

		.product-name {
			margin-bottom: 8px;
			min-height: 2.2lh;

			:global(a) {
				display: block;
				color: black;
				text-decoration: none;
				@include font(h4);

				@include media(phone) {
					hyphens: auto;
				}
			}
		}

		.content {
			display: flex;
			align-items: flex-end;
			padding: 10px 10px 10px 10px;
			transition: all 0.3s ease;
			border-image-width: 8px;
			border-image-slice: 32 32;
			border-image-outset: 8px;
			border-image-repeat: round;
			background: white;
			z-index: 2;
			border-image-source: var(--border-white);

			.text {
				container-type: inline-size;
				width: 100%;
			}

			.compare-price {
				opacity: 0.6;
				text-decoration: line-through;

				@media (max-width: 600px) {
					display: block;
					width: 100%;
				}
			}

			.product-name a {
				transition: all 0.3s ease;
			}

			.row {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 6px 0;
				min-height: 42px;
				gap: v(content-padding);

				&.center {
					gap: 0;
					.left {
						overflow: hidden;
						text-overflow: hidden;
					}
					.divider,
					.divider-v {
						flex-shrink: 1;
						flex-grow: 0;
					}
					.right {
						padding-inline-start: v(content-padding);
						flex-shrink: 0;
					}
				}

				&.bottom {
					padding-bottom: 0;
					gap: 0;
				}
			}

			.divider {
				width: 100%;
				height: 1px;
				background: color(black);

				&.mobile {
					display: none;
				}

				&.desktop {
					display: block;
				}
			}

			@container (max-width: 300px) {
				.row.center {
					flex-direction: column;
					align-items: flex-start;
					gap: 6px;

					.divider-v {
						display: none;
					}

					.right {
						padding-inline-start: 0;
						width: 100%;
						padding-top: 4px;
					}

					.left {
						padding: 4px 0;
					}
				}

				.divider {
					&.desktop {
						display: none;
					}

					&.mobile {
						display: block;
					}
				}

				.row.bottom {
					padding-top: 0;
				}
			}

			.description {
				@include font(text-sm);
				margin-top: 0.3rem;
				text-transform: capitalize;
			}

			.variant-select {
				width: 100%;

				@include media(phone) {
					margin-top: 4px;
				}
			}

			.divider-v {
				width: 1px;
				height: 30px;
				background: color(black);
			}

			.price {
				@include font(h5);
				color: color(black);
				transition: all 0.3s ease;
				margin-top: 0.3rem;

				@include media(phone) {
					margin-inline-start: 4px;
				}
			}

			.vat {
				display: none;
				margin-inline-start: 8px;
				margin-bottom: 1px;
				opacity: 0.5;
				@include font(text-xs);
			}

			.country {
				display: flex;
				flex-direction: column;
				@include font(text-sm);
				margin-inline-start: 32px;

				@include media(phone) {
					display: none;
				}

				img {
					margin-bottom: 4px;
				}
			}

			.left {
				height: 100%;
				width: 100%;
				display: flex;
				align-items: flex-end;
			}

			.right {
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				gap: v(content-gap-sm);

				&.select-col {
					flex-shrink: 0;

					@include media(phone) {
						width: 100%;
					}
				}

				:global(.button) {
					width: 100%;
					transition: all 0.3s ease;
					opacity: 0;
					transform: translateY(-16px);

					@include media(tablet) {
						opacity: 1;
						transform: translateY(0);
					}
				}
			}
		}

		/*
		&:hover {
			.content {
				background: color(primary);
				color: white;

				.product-name a,
				.price {
					color: white;
				}
			}
		}
    */

		.add-button {
			border: 0;
			background: transparent;
			display: flex;
			align-items: center;
			gap: 12px;
			color: white;
			padding: 6px 12px;
			padding-inline-end: 0;
			border-radius: 4px;
			transition: all 0.3s ease;

			.button-text {
				display: none;
				@include font(h6);
				white-space: nowrap;
				margin-top: 0.15rem;
			}

			:global(svg),
			:global(svg path) {
				max-height: 30px;
				height: 1.2em;
				width: auto;
				transition: all 0.3s ease;
			}
		}

		@media (hover: hover) {
			&:not(.no-hover):hover {
				.overlay {
					.text {
						opacity: 1;
						color: black;
						margin-top: v(content-padding);
						:global(p) {
							color: black !important;
						}
					}

					.overlay-media {
						opacity: 1;
					}
				}

				.content {
					background: color(yellow);
					border-image-source: var(--border-yellow);

					.right {
						:global(.button) {
							opacity: 1;
							transform: translateY(0);
						}
					}

					.add-button {
						background: black;
						padding-inline-end: 12px;

						.button-text {
							display: inline-block;
						}

						:global(svg) {
							z-index: 1;
							// height: 2rem;
							// width: 2rem;
						}

						:global(svg),
						:global(svg path) {
							stroke: white;
						}
					}

					:global(select) {
						background-color: color(yellow_01) !important;
					}
				}
			}
		}
	}
	.subscribe-button {
		width: 100%;
		margin-top: v(content-gap-xs);
		:global(button) {
			width: 100%;
			display: flex;
			justify-content: center;
		}
		:global(a) {
			width: 100%;
		}
	}
</style>
